<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="formPageConfig.title | translate"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <div class="row">
        <section class="tw-pr-2 tw-pl-0 tw-w-full tw-mt-2 xl:tw-w-2/6">
          <fieldset class="!tw-h-full">
            <legend>
              {{ "common.sendDateTimeType" | translate }}
            </legend>

            <div>
              <!--senderNumberId-->
              <div>
                <private-number-select-search
                  class="tw-w-full"
                  label="common.senderNumberId"
                  [sendType]="SendTypes.Dynamic"
                  [useType]="UseTypes.Normal"
                  [isShowRefreshBtn]="true"
                  [control]="form?.get('senderNumberId')"
                  [(value)]="model.privateNumberId"
                  (itemChange)="isCanSendFlashSms = $event?.isCanSendFlashSms"
                >
                </private-number-select-search>
              </div>

              <!--dateTimeNext-->
              <div>
                <app-date-time-picker
                  class="tw-mt-3 tw-w-full"
                  [config]="directDateTimeConfig"
                  (dateTime)="model.dateTimeNext = $event"
                >
                </app-date-time-picker>
              </div>

              <!-- description -->
              <div>
                <form-textarea
                  class="tw-w-full"
                  label="common.description"
                  [(value)]="model.description"
                  [control]="form?.get('description')"
                  [rows]="8"
                >
                </form-textarea>
              </div>

              <!--isFlashSms-->
              <div *ngIf="isCanSendFlashSms">
                <mat-slide-toggle
                  [(ngModel)]="model.isFlashSms"
                  formControlName="isFlashSms"
                >
                  {{ "common.isFlashSms" | translate }}
                </mat-slide-toggle>
              </div>
            </div>
          </fieldset>
        </section>

        <!--phonebook-->
        <section class="tw-pr-2 tw-pl-0 tw-w-full tw-mt-2 xl:tw-w-4/6">
          <fieldset class="tw-h-full tw-grid">
            <legend class="tw-flex-center">
              <i class="mdi mdi-card-account-phone tw-ml-2"></i>
              {{ "common.phonebook" | translate }}
            </legend>

            <div>
              <phonebook-selector
                [isShowInputs]="true"
                [isShowGlobalIndex]="false"
                (recipientsChange)="changeRecipients($event)"
              >
              </phonebook-selector>
            </div>
          </fieldset>
        </section>
      </div>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="true"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
